import { Injectable } from "@angular/core";
import { DefaultTranspiler, TranslocoTranspiler, TranspileParams } from "@jsverse/transloco";
import { get } from "lodash-es";

@Injectable()
export class TranslocoRefTranspiler extends DefaultTranspiler implements TranslocoTranspiler {
  transpile(params: TranspileParams) {
    if (typeof params.value === "string") {
      params = {
        ...params,
        value: params.value.replace(/@:([\w.]+)/g, (_, ref) => {
          const resolved = get(params.translation, ref);
          return typeof resolved === "string"
            ? this.transpile({ ...params, value: resolved, key: ref })
            : ref;
        }),
      };
    }
    return super.transpile(params);
  }
}